import { Pipe, PipeTransform } from '@angular/core';
import { CartItem } from '../types/cart';
import { WeekDay } from '../api/contracts/menu';
import { WeekIndex } from '../types/menu';

@Pipe({
  name: 'filterCartItemsByDay',
})
export class FilterCartItemsByDayPipe implements PipeTransform {
  transform(
    cartItems: CartItem[],
    day: WeekDay,
    weekNumber: number | null
  ): CartItem[] {    
    if (weekNumber === null) {
      return cartItems.filter((item) => item.day === day);
    }
    return cartItems.filter(
      (item) => item.day === day && item.weekNumber === weekNumber
    );
  }
}
